'use strict';

/* global jQuery yith_wcaf yith */

// these constants will be wrapped inside webpack closure, to prevent collisions

const $ = jQuery,
	$document = $( document ),
	$body = $( 'body' ),
	block = ( $el ) => {
		if ( 'undefined' === typeof $.fn.block ) {
			return false;
		}

		try {
			$el.block( {
				message: null,
				overlayCSS: {
					background: '#fff',
					opacity: 0.6,
				},
			} );

			return $el;
		} catch ( e ) {
			return false;
		}
	},
	unblock = ( $el ) => {
		if ( 'undefined' === typeof $.fn.unblock ) {
			return false;
		}

		try {
			$el.unblock();
		} catch ( e ) {
			return false;
		}
	},
	confirm = ( title, message, args ) => {
		return new Promise( ( resolve, reject ) => {
			// if can't display modal, accept by default
			if ( 'undefined' === typeof yith?.ui?.confirm ) {
				reject( new Error( 'Missing yith.ui utilities' ) );
			}

			let options = {
				title: title || labels.generic_confirm_title,
				message: message || labels.generic_confirm_message,
				...args,
			};

			options.onConfirm = () => resolve( true );
			options.onCancel = reject;

			yith.ui.confirm( options );
		} );
	},
	ajaxUrl = yith_wcaf?.ajax_url,
	nonces = yith_wcaf?.nonces,
	labels = yith_wcaf?.labels;

export {
	$,
	$document,
	$body,
	block,
	unblock,
	confirm,
	ajaxUrl,
	nonces,
	labels,
};
